import template from './template'
import store from './store'

export default{
    template,
    store
}